export default function reducer(state, action) {
  switch (action.type) {
    case "SET_STATUS":
      return {
        ...state,
        status: action.payload
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload
      };
    case "SET_CHILD_DATA":
      return {
        ...state,
        childData: action.payload
      };
    case "ADD_CHILD_NOT_FOUND":
      return {
        ...state,
        childNotFoundList: [action.payload, ...state.childNotFoundList]
      };
    case "SET_LOOKUP_ERROR":
      return {
        ...state,
        lookupError: action.payload
      };
    default:
      return state;
  }
}
